import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm._f("showMoreFilter")(
            _vm.text,
            _vm.showMoreBtn(_vm.text),
            _vm.showMore
          )
        )
      ),
    ]),
    _vm._v(" "),
    _vm.showMoreBtn(_vm.text)
      ? _c(
          "button",
          {
            staticClass: "show-more-text-button",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.showMore = !_vm.showMore
              },
            },
          },
          [
            _c(VIcon, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.showMore ? "mdi-chevron-up" : "mdi-chevron-down") +
                  "\n    "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }